import React from 'react';
import { isThreadServiceEnabled } from 'src/graphql/thread-service.helpers';
import TwilioServiceList from 'src/screens/Now/components/ServicesList/TwilioServiceList';
import ThreadServiceList from 'src/screens/Now/components/ServicesList/ThreadServiceList';

export const ServicesList = () => {
  const shouldUseTwilio = !isThreadServiceEnabled();

  if (shouldUseTwilio) {
    return <TwilioServiceList />;
  }

  return <ThreadServiceList />;
};
